/**
 * normalizeMediaUrl — reduce a CG-media URL to its relative, unsigned path.
 *
 * Absolute, SIGNED media URLs (`https://host/api/clients/:id/media/:mid?exp=…&sig=…`)
 * are built for Presenter Engine, which is session-less. The browser is not:
 * it carries the viewer's session (or share link), so it needs neither the
 * signature (which EXPIRES) nor the host (which goes stale when the app
 * moves, or differs from the address bar and then drops the cookie). Every
 * <img> the app draws from a scene, poster or script preview goes through
 * here. Non-media URLs are returned untouched; the `v=` rendition is kept.
 */
export function normalizeMediaUrl(url) {
  if (!url || typeof url !== "string") return url;
  const m = url.match(/\/api\/clients\/[^/]+\/media\/[^/?#]+/);
  if (!m) return url;
  const path = m[0];
  const vMatch = url.match(/[?&](v=[^&]+)/);
  return vMatch ? `${path}?${vMatch[1]}` : path;
}
